module.exports = __webpack_public_path__ + "./img/Feedback-icon.ba431f24b6f1e234f90c40be04efcda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/feedback/Feedback-icon.png
// module id = ./src/components/feedback/Feedback-icon.png
// module chunks = 0